import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Select,
  Text,
  Textarea,
} from "@chakra-ui/react";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import { sendBulkCustomMessageToPhonesRequest } from "../../../modules/admin-modules/asquera-practice/Actions";

const TEMPLATE_PARENTS = "0";
const TEMPLATE_STUDENTS = "1";

const parsePhones = (phonesText) =>
  phonesText
    .split(/\r?\n/)
    .map((phone) => phone.trim())
    .filter(Boolean);

const BulkMessageToPhones = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const userLoading = useSelector((state) => state.user.isLoading);
  const isSending = useSelector(
    (state) => state.asqueraPractice.sendBulkMessageLoading
  );

  const [phonesText, setPhonesText] = useState("");
  const [template, setTemplate] = useState(TEMPLATE_PARENTS);
  const [message, setMessage] = useState("");
  const [msg1, setMsg1] = useState("");
  const [msg2, setMsg2] = useState("");
  const [msg3, setMsg3] = useState("");

  const phones = parsePhones(phonesText);
  const isStudentsTemplate = template === TEMPLATE_STUDENTS;
  const canSubmit = isStudentsTemplate
    ? phones.length > 0 && msg1.trim() && msg2.trim() && msg3.trim()
    : phones.length > 0 && message.trim();

  const isSuperAdmin =
    user?.role &&
    Array.isArray(user.role) &&
    user.role[0]?.name === "Super Admin";

  React.useEffect(() => {
    if (userLoading) return;
    if (user?.role && Array.isArray(user.role) && !isSuperAdmin) {
      navigate("/dashboard/students");
    }
  }, [user, userLoading, isSuperAdmin, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    const payload = isStudentsTemplate
      ? {
          phones,
          template: Number(TEMPLATE_STUDENTS),
          msg_1: msg1.trim(),
          msg_2: msg2.trim(),
          msg_3: msg3.trim(),
        }
      : {
          phones,
          template: Number(TEMPLATE_PARENTS),
          message: message.trim(),
        };

    dispatch(
      sendBulkCustomMessageToPhonesRequest(payload, () => {
        setPhonesText("");
        setMessage("");
        setMsg1("");
        setMsg2("");
        setMsg3("");
      })
    );
  };

  if (userLoading || !user?.role) return null;
  if (!isSuperAdmin) return null;

  return (
    <Layout>
      <Box minHeight="400px">
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="10000000"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            رسالة مخصصة للهواتف / Bulk Custom Message to Phones
          </Text>
          <LogoutMenu />
        </Flex>

        <Box
          as="form"
          onSubmit={handleSubmit}
          maxW="700px"
          p={6}
          bg="white"
          borderRadius="lg"
          boxShadow="md"
          border="1px solid"
          borderColor="gray.200"
        >
          <FormControl isRequired mb={4}>
            <FormLabel>أرقام الهواتف / Phones</FormLabel>
            <Textarea
              value={phonesText}
              onChange={(e) => setPhonesText(e.target.value)}
              placeholder={"01012345678\n01112345678\n01212345678"}
              rows={10}
              size="lg"
              dir="ltr"
            />
            <Text fontSize="sm" color="gray.600" mt={2}>
              Paste one phone number per line. {phones.length} phone(s)
              detected.
            </Text>
          </FormControl>

          <FormControl isRequired mb={4}>
            <FormLabel>القالب / Template</FormLabel>
            <Select
              value={template}
              onChange={(e) => setTemplate(e.target.value)}
              size="lg"
            >
              <option value={TEMPLATE_PARENTS}>أولياء الأمور / Parents</option>
              <option value={TEMPLATE_STUDENTS}>الطلاب / Students</option>
            </Select>
          </FormControl>

          {isStudentsTemplate ? (
            <>
              <FormControl isRequired mb={4}>
                <FormLabel>السطر الأول / Message line 1</FormLabel>
                <Textarea
                  value={msg1}
                  onChange={(e) => setMsg1(e.target.value)}
                  placeholder="msg_1"
                  rows={3}
                  size="lg"
                />
              </FormControl>
              <FormControl isRequired mb={4}>
                <FormLabel>السطر الثاني / Message line 2</FormLabel>
                <Textarea
                  value={msg2}
                  onChange={(e) => setMsg2(e.target.value)}
                  placeholder="msg_2"
                  rows={3}
                  size="lg"
                />
              </FormControl>
              <FormControl isRequired mb={6}>
                <FormLabel>السطر الثالث / Message line 3</FormLabel>
                <Textarea
                  value={msg3}
                  onChange={(e) => setMsg3(e.target.value)}
                  placeholder="msg_3"
                  rows={3}
                  size="lg"
                />
              </FormControl>
            </>
          ) : (
            <FormControl isRequired mb={6}>
              <FormLabel>الرسالة / Message</FormLabel>
              <Textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Enter message..."
                rows={6}
                size="lg"
              />
            </FormControl>
          )}

          <Button
            type="submit"
            colorScheme="orange"
            color="white"
            isLoading={isSending}
            loadingText="جاري الإرسال..."
            isDisabled={!canSubmit}
          >
            إرسال / Send
          </Button>
        </Box>
      </Box>
    </Layout>
  );
};

export default BulkMessageToPhones;
